import { render, staticRenderFns } from "./MEX.vue?vue&type=template&id=677c2d54&scoped=true&"
import script from "./MEX.vue?vue&type=script&lang=js&"
export * from "./MEX.vue?vue&type=script&lang=js&"
import style0 from "./MEX.vue?vue&type=style&index=0&id=677c2d54&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "677c2d54",
  null
  
)

export default component.exports